
import {useLocation} from "react-router-dom";
import {useNavigate} from "react-router";
//import {useHeaderScroll} from "../../hooks/useHeaderScroll.ts";

export default function Header() {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div id="vc_header">

            <div className="vc_section">
                <div className="header_wrapper">
                    <div className="header_left">
                        <h1 className="header_title">Verifiable Credentials Ecosystem</h1>
                        <h2 className="header_subtitle">by MyNextID</h2>
                    </div>

                    <div></div>
                    
                </div>
            </div>
        </div>
    )
}
